<div class="shell-navigation-container">
  @let isExpanded = expanded();

  <section class="z-10 shell-navigation-section">
    <ul class="flex flex-col w-full shell-navigation-list">
      <!-- Home -->
      <li class="navigation-item"
          [class.active]="isCurrentSection('Home')"
          mirTooltip
            [placement]="'right'"
            tooltip="RapidViews BI Smart Repository">
        <button class="navigation-item-link"
             (click)="handleSelectSection('Home')">
          <MirIcon>{{subsectionIconName('Home')}}</MirIcon>
          <span class="navigation-item-label">
            BI Smart Repository
          </span>
        </button>
      </li>
      <!-- DataSearch -->
      <li class="navigation-item"
          [class.active]="isCurrentSection('DataSearch')"
          mirTooltip
            [placement]="'right'"
            tooltip="Data Search">
        <button class="navigation-item-link"
             (click)="handleSelectSection('DataSearch')">
          <MirIcon>{{subsectionIconName('DataSearch')}}</MirIcon>
          <span class="navigation-item-label">
            {{'Shell.Sections.DataSearch' | translate}}</span>
        </button>
      </li>
    </ul>
  </section>

  <section class="z-10 shell-navigation-section">
    <ul class="flex flex-col w-full shell-navigation-list">
      <!-- BusinessCatalog -->
      @if (hasFeature('ReferentialCompanyBusinessCatalog')) {
        <li class="navigation-item
                   group/BusinessCatalog
                   hover:!overflow-visible
                   focus-within:!overflow-visible"
            [class.active]="isCurrentSection('BusinessCatalog')">
          <button class="navigation-item-link"
              (click)="handleSelectSection('BusinessCatalog')">
          <MirIcon>{{subsectionIconName('BusinessCatalog')}}</MirIcon>
            <span class="navigation-item-label">
              {{'Shell.Sections.BusinessCatalog' | translate}}
            </span>
          </button>
          <div class="absolute bottom-0 -right-1 rotate-45">
            <MirIcon size="lg" class="">arrow_right</MirIcon>
          </div>

          <ul class="subsection-menu-container
                      group-hover/BusinessCatalog:!block
                      group-hover/BusinessCatalog:!opacity-100
                      group-focus-within/BusinessCatalog:!block
                      group-focus-within/BusinessCatalog:!opicty-100">
            @for (subsection of buzinessCatalogSubsections(); track subsection.key) {
              @if (hasFeature(subsection.feature)) {
                <li class="subsection-menu-item"
                    [class.active]="isCurrentSection(subsection.key)"
                    (click)="handleSelectSection(subsection.key)">
                  @if (isCurrentSection(subsection.key)) {
                    <MirIcon>check</MirIcon>
                  }
                  @else {
                    <MirIcon>{{subsectionIconName(subsection.key)}}</MirIcon>
                  }
                  {{subsectionKeyName(subsection.key) | translate}}
                </li>
              }
            }
          </ul>
        </li>
      }

      <!-- Hub -->
      @if (hasFeature('ReferentialCompanyHub')) {
        <li class="navigation-item
                   group/Hubs
                   hover:!overflow-visible
                   focus-within:!overflow-visible"
            [class.active]="isCurrentSection('Hubs')">
          <button class="navigation-item-link"
              (click)="handleSelectSection('Hubs')">
          <MirIcon>{{subsectionIconName('Hubs')}}</MirIcon>
            <span class="navigation-item-label">
              {{'Shell.Sections.Hubs' | translate}}
            </span>
          </button>
          <div class="absolute bottom-0 -right-1 rotate-45">
            <MirIcon size="lg" class="">arrow_right</MirIcon>
          </div>

          <ul class="subsection-menu-container
                      group-hover/Hubs:!block
                      group-hover/Hubs:!opacity-100
                      group-focus-within/Hubs:!block
                      group-focus-within/Hubs:!opicty-100">

            @for (subsection of hubsSubsections(); track subsection.key) {
              <li class="subsection-menu-item text-white"
                  [class.active]="isCurrentSection(subsection.key)"
                  (click)="handleSelectSection(subsection.key)">
                @if (isCurrentSection(subsection.key)) {
                  <MirIcon>check</MirIcon>
                }
                @else {
                  @if (useIcon(subsection.key)) {
                    <MirIcon>{{subsectionIconName(subsection.key)}}</MirIcon>
                  }
                  @else {
                    @if (subsection.key === 'AnalyticsHub') {
                      <ng-container [ngTemplateOutlet]="AnalyticsHub"></ng-container>
                    }
                    @else if (subsection.key === 'KPIsHub') {
                      <ng-container [ngTemplateOutlet]="KPIsHub"></ng-container>
                    }
                  }
                }
                {{subsectionKeyName(subsection.key) | translate}}
              </li>
            }
          </ul>
        </li>
      }
    </ul>
  </section>

  <section class="z-10 shell-navigation-section">
    <ul class="flex flex-col w-full shell-navigation-list">
      <!-- Wizard -->
      @if (hasFeature('ReferentialCompanyWizard')) {
        <li class="navigation-item
                   group/Wizard
                   hover:!overflow-visible
                   focus-within:!overflow-visible"
            [class.active]="isCurrentSection('Wizard')">
          <button class="navigation-item-link"
              (click)="handleSelectSection('Wizard')">
          <MirIcon>{{subsectionIconName('Wizard')}}</MirIcon>
            <span class="navigation-item-label">
              {{'Shell.Sections.Wizard' | translate}}
            </span>
          </button>
          <div class="absolute bottom-0 -right-1 rotate-45">
            <MirIcon size="lg" class="">arrow_right</MirIcon>
          </div>

          <ul class="subsection-menu-container
                      group-hover/Wizard:!block
                      group-hover/Wizard:!opacity-100
                      group-focus-within/Wizard:!block
                      group-focus-within/Wizard:!opicty-100">

            @for (subsection of wizardSubsections(); track subsection.key) {
              @if (hasFeature(subsection.feature)) {
                <li class="subsection-menu-item"
                    [class.active]="isCurrentSection(subsection.key)"
                    [class.disabled]="isDisabled(subsection.key)"
                    (click)="handleSelectSection(subsection.key)">
                  @if (isCurrentSection(subsection.key)) {
                    <MirIcon>check</MirIcon>
                  }
                  @else {
                    <MirIcon>{{subsectionIconName(subsection.key)}}</MirIcon>
                  }
                  {{subsectionKeyName(subsection.key) | translate}}
                </li>
              }
            }
          </ul>
        </li>
      }

      <!-- Audit -->
      @if (hasFeature('ReferentialCompanyAudit')) {
        <li class="navigation-item"
            [class.active]="isCurrentSection('Audit')"
              mirTooltip
              [placement]="'right'"
              [tooltip]="'Audit.Title' | translate">
          <button class="navigation-item-link"
              (click)="handleSelectSection('Audit')">
            <MirIcon>{{subsectionIconName('Audit')}}</MirIcon>
            <span class="navigation-item-label">
              Audit
            </span>
          </button>
        </li>
      }
    </ul>
  </section>

  <div class="flex-auto"></div>

  <section class="shell-navigation-section z-10">
    <ul class="shell-navigation-list">

      <!-- CustomIntegrator -->
      @if (hasFeature('ReferentialCompanyIntegrator')) {
        <li class="navigation-item"
            [class.active]="isCurrentSection('CustomIntegrator')"
            mirTooltip
              [disable]="isExpanded"
              [placement]="'right'"
              [tooltip]="'Shell.Sections.CustomIntegrator' | translate">
          <button class="navigation-item-link"
              (click)="handleSelectSection('CustomIntegrator')">
          <MirIcon>{{subsectionIconName('CustomIntegrator')}}</MirIcon>
            <span class="navigation-item-label">
              {{'Shell.Sections.CustomIntegrator' | translate}}
            </span>
          </button>
        </li>
      }

      <!-- Administration -->
      @if (hasFeature('Administration')) {
        <li class="navigation-item"
            [class.active]="isCurrentSection('Administration')"
            mirTooltip
              [disable]="isExpanded"
              [placement]="'right'"
              [tooltip]="'Shell.Sections.Administration' | translate">
          <button class="navigation-item-link"
              (click)="handleSelectSection('Administration')">
          <MirIcon>{{subsectionIconName('Administration')}}</MirIcon>
            <span class="navigation-item-label">
              {{'Shell.Sections.Administration' | translate}}
            </span>
          </button>
        </li>
      }

      <!-- Contact -->
      <li class="navigation-item"
          mirTooltip
              [disable]="isExpanded"
              [placement]="'right'"
              [tooltip]="'Shell.Support' | translate">
        <button class="navigation-item-link"
            (click)="openContactPage()">
          <MirIcon color="white">support_agent</MirIcon>
          <span class="navigation-item-label ">
            {{'Shell.Support' | translate}}
          </span>
        </button>
      </li>
    </ul>
  </section>

  <section class="shell-navigation-ui
                  z-40 absolute top-[calc(50%_-_2em)] right-0 h-16
                  flex items-center
                  bg-white bg-opacity-25 rounded-l
                  hover:bg-opacity-35
                  cursor-pointer"
      (click)="handleToggleExpand()">
    <MirIcon class="!text-white opacity-75 hover:opacity-100
                     group-[.expanded]/ShellNav:rotate-180">
      chevron_right
    </MirIcon>
  </section>
</div>

<ng-template #AnalyticsHub>
  <svg class="fill-current stroke-current" width="24px" height="24px"
      viewBox="0 -960 960 960"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg">
    <path d="m180-270q-37.5 0-63.75-26.25t-26.25-63.75 26.25-63.75 63.75-26.25q10.5 0 19.5 2.25t17.25 6l42.75-53.25q-21-23.25-29.25-52.5t-3.75-58.5l-60.75-20.25q-12.75 18.75-32.25 30t-43.5 11.25q-37.5 0-63.75-26.25t-26.25-63.75 26.25-63.75 63.75-26.25 63.75 26.25 26.25 63.75v6l60.75 21q15-27 40.125-45.75t56.625-24v-65.25q-29.25-8.25-48.375-31.875t-19.125-55.125q0-37.5 26.25-63.75t63.75-26.25 63.75 26.25 26.25 63.75q0 31.5-19.5 55.125t-48 31.875v65.25q31.5 5.25 56.625 24t40.125 45.75l60.75-21v-6q0-37.5 26.25-63.75t63.75-26.25 63.75 26.25 26.25 63.75-26.25 63.75-63.75 26.25q-24 0-43.875-11.25t-31.875-30l-60.75 20.25q4.5 29.25-3.75 58.125t-29.25 52.875l42.75 52.5q8.25-3.75 17.25-5.625t19.5-1.875q37.5 0 63.75 26.25t26.25 63.75-26.25 63.75-63.75 26.25-63.75-26.25-26.25-63.75q0-15 4.875-28.875t13.125-25.125l-42.75-53.25q-30.75 17.25-65.625 17.25t-65.625-17.25l-42 53.25q8.25 11.25 13.125 25.125t4.875 28.875q0 37.5-26.25 63.75t-63.75 26.25zm-90-375q12.75 0 21.375-8.625t8.625-21.375-8.625-21.375-21.375-8.625-21.375 8.625-8.625 21.375 8.625 21.375 21.375 8.625zm90 315q12.75 0 21.375-8.625t8.625-21.375-8.625-21.375-21.375-8.625-21.375 8.625-8.625 21.375 8.625 21.375 21.375 8.625zm180-510q12.75 0 21.375-8.625t8.625-21.375-8.625-21.375-21.375-8.625-21.375 8.625-8.625 21.375 8.625 21.375 21.375 8.625zm0 330q31.5 0 53.25-21.75t21.75-53.25-21.75-53.25-53.25-21.75-53.25 21.75-21.75 53.25 21.75 53.25 53.25 21.75zm180 180q12.75 0 21.375-8.625t8.625-21.375-8.625-21.375-21.375-8.625-21.375 8.625-8.625 21.375 8.625 21.375 21.375 8.625zm90-315q12.75 0 21.375-8.625t8.625-21.375-8.625-21.375-21.375-8.625-21.375 8.625-8.625 21.375 8.625 21.375 21.375 8.625z"
        stroke-width="6"
        stroke="currentColor"/>
    <path d="m586.67-106.67h53.333v-133.33h-53.333zm213.33 0h53.333v-266.67h-53.333zm-106.67 0h53.333v-80h-53.333zm0-133.33h53.333v-53.333h-53.333zm-160 240q-22 0-37.667-15.667-15.667-15.667-15.667-37.667v-373.33q0-22 15.667-37.667 15.667-15.667 37.667-15.667h373.33q22 0 37.667 15.667 15.667 15.667 15.667 37.667v373.33q0 22-15.667 37.667-15.667 15.667-37.667 15.667zm0-53.333h373.33v-373.33h-373.33zm0-373.33v373.33z"
        stroke-width="6"
        stroke="currentColor"/>
  </svg>
</ng-template>

<ng-template #KPIsHub>
  <svg class="fill-current stroke-current" width="24px" height="24px"
    viewBox="0 -960 960 960"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg">
    <path d="m180-270q-37.5 0-63.75-26.25t-26.25-63.75 26.25-63.75 63.75-26.25q10.5 0 19.5 2.25t17.25 6l42.75-53.25q-21-23.25-29.25-52.5t-3.75-58.5l-60.75-20.25q-12.75 18.75-32.25 30t-43.5 11.25q-37.5 0-63.75-26.25t-26.25-63.75 26.25-63.75 63.75-26.25 63.75 26.25 26.25 63.75v6l60.75 21q15-27 40.125-45.75t56.625-24v-65.25q-29.25-8.25-48.375-31.875t-19.125-55.125q0-37.5 26.25-63.75t63.75-26.25 63.75 26.25 26.25 63.75q0 31.5-19.5 55.125t-48 31.875v65.25q31.5 5.25 56.625 24t40.125 45.75l60.75-21v-6q0-37.5 26.25-63.75t63.75-26.25 63.75 26.25 26.25 63.75-26.25 63.75-63.75 26.25q-24 0-43.875-11.25t-31.875-30l-60.75 20.25q4.5 29.25-3.75 58.125t-29.25 52.875l42.75 52.5q8.25-3.75 17.25-5.625t19.5-1.875q37.5 0 63.75 26.25t26.25 63.75-26.25 63.75-63.75 26.25-63.75-26.25-26.25-63.75q0-15 4.875-28.875t13.125-25.125l-42.75-53.25q-30.75 17.25-65.625 17.25t-65.625-17.25l-42 53.25q8.25 11.25 13.125 25.125t4.875 28.875q0 37.5-26.25 63.75t-63.75 26.25zm-90-375q12.75 0 21.375-8.625t8.625-21.375-8.625-21.375-21.375-8.625-21.375 8.625-8.625 21.375 8.625 21.375 21.375 8.625zm90 315q12.75 0 21.375-8.625t8.625-21.375-8.625-21.375-21.375-8.625-21.375 8.625-8.625 21.375 8.625 21.375 21.375 8.625zm180-510q12.75 0 21.375-8.625t8.625-21.375-8.625-21.375-21.375-8.625-21.375 8.625-8.625 21.375 8.625 21.375 21.375 8.625zm0 330q31.5 0 53.25-21.75t21.75-53.25-21.75-53.25-53.25-21.75-53.25 21.75-21.75 53.25 21.75 53.25 53.25 21.75zm180 180q12.75 0 21.375-8.625t8.625-21.375-8.625-21.375-21.375-8.625-21.375 8.625-8.625 21.375 8.625 21.375 21.375 8.625zm90-315q12.75 0 21.375-8.625t8.625-21.375-8.625-21.375-21.375-8.625-21.375 8.625-8.625 21.375 8.625 21.375 21.375 8.625z"
      stroke-width="6"
      stroke="currentColor"/>
    <path d="m652.23-107.62q-16.271 11.441-35.94 8.0475-19.669-3.3937-31.018-19.601-11.349-16.207-7.8437-35.896 3.5052-19.689 19.776-31.13 16.271-11.441 35.94-8.0475 19.669 3.3937 31.018 19.601 11.349 16.207 7.8437 35.896-3.5052 19.689-19.776 31.13zm55.025 78.579q-49.306 34.67-107.89 24.561-58.588-10.109-92.979-59.221-34.391-49.112-23.95-107.76 10.441-58.648 59.747-93.318 33.035-23.229 71.256-25.918 38.221-2.6884 72.57 12.737l173.56-122.04 100.44 17.33-26.848 150.81-60.08-1.7307-18.811 57.203-62.545 2e-3 -23.174 16.295q2.7929 37.615-12.73 72.717-15.523 35.102-48.558 58.331zm-27.513-39.289q27.612-19.415 36.874-50.848 9.2624-31.433-1.7178-61.825l61.633-43.338 42.698 0.027 19.453-58.388 53.922 2.3955 11.187-62.837-33.479-5.7766-182.93 128.63q-24.786-20.684-57.434-22.647-32.648-1.9631-60.26 17.452-32.542 22.882-39.553 62.26-7.0104 39.378 15.687 71.791 22.698 32.414 62.035 39.201 39.338 6.7875 71.88-16.095z"
      stroke-width="6"
      stroke="currentColor"/>
  </svg>
</ng-template>
